module.exports = __webpack_public_path__ + "8048c6e1d32674e8e65ccc52295a4691.svg";